import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AgmCoreModule } from '@agm/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContactComponent } from './contact/contact.component';
import { Error404Component } from './error/error-404.component';
import { HomeComponent } from './home/home.component';
import { MetaService } from './meta.service';
import { BuildingBlocksModule } from './project/building-blocks/building-blocks.module';

import { ContactService } from './contact/contact.service';
import { ParallaxModule } from './parallax.module';
import { ProjectModule } from './project/project.module';
import { ScrollService } from './scroll.service';
import { SlackWebhookService } from './slack-webhook.service';

@NgModule({
    declarations: [
        AppComponent,
        Error404Component,
        HomeComponent,
        ContactComponent,
    ],
    imports: [
        BuildingBlocksModule,
        ProjectModule,
        AppRoutingModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        ParallaxModule,
        AgmCoreModule.forRoot({
            apiKey: null,
        }),
    ],
    providers: [
        ContactService,
        MetaService,
        ScrollService,
        SlackWebhookService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/app.module.ts